import styled from 'styled-components'
import { Chip } from '@navent-jobs/ui-kit/components/chip'

export const CustomChip = styled(Chip)`
  i:before {
    background-color: ${({ theme }) => theme.colors.extra.normal} !important;
  }
`
